import React from "react";

const HeaderSocials = () => {
  return (
    <div className="home__socials">
      <a
        href="https://www.instagram.com/babi752?igsh=YnZyeHY4bm5jZmV6&utm_source=qr"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-instagram"></i>
      </a>

      <a
        href="https://www.tiktok.com/@babi7528?_t=ZM-8vimDU3meTm&_r=1"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-tiktok"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/barbara-luciano-araujo/"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-linkedin"></i>
      </a>

      <a
        href="https://github.com/babi2707"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-github"></i>
      </a>
    </div>
  );
};

export default HeaderSocials;
